import { useRequestAccess } from '#pplx/frontend/apps/ask/access/useRequestAccess.js';
import { maybeSlugToUuid } from '#pplx/frontend/apps/ask/permalink-slug/permalinkSlug.js';
import { toPublicWebUrlForCurrentLocation } from '#pplx/frontend/common/location.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { useEffect, useRef } from 'react';
// Opens the access gate for a denied resource without navigating, so the denied
// URL stays in the address bar: these routes are mobile deep-link targets and
// the Smart App Banner's OPEN button opens whatever URL is showing. Renders
// nothing itself — the surface it replaces is intentionally blank behind the
// modal.
export function RequestAccessOnMount({ uuidOrSlug, redirectBasePath, subject, dismissHref, }) {
    const router = useRouter();
    const { handleRequestAccess, isRequestAccessReady } = useRequestAccess({
        redirectBasePath,
        subject,
    });
    const openedSlugRef = useRef(undefined);
    useEffect(() => {
        if (!isRequestAccessReady || openedSlugRef.current === uuidOrSlug)
            return;
        openedSlugRef.current = uuidOrSlug;
        const openedAtPathname = window.location.pathname;
        // Legacy thread permalinks are `<slugified-title>-<base64uuid>` where the
        // title is user-authored query text; canonicalize to the bare UUID before
        // it reaches logs and the request-access API path. Asset and space slugs
        // are opaque and pass through unchanged.
        const identifier = subject === undefined || subject === 'thread'
            ? (maybeSlugToUuid(uuidOrSlug) ?? uuidOrSlug)
            : uuidOrSlug;
        handleRequestAccess(identifier, {
            // Deep links select content through the query and fragment, so the
            // post-login return target has to carry the whole address.
            overrideRedirectUrl: toPublicWebUrlForCurrentLocation(),
            closeCallback: () => {
                // The modal store fires this on ANY removal, not just user dismissal —
                // including replace-mode opens from unrelated features and closes that
                // happen after the visitor already navigated away. Only leave the page
                // if they are still parked on the gated URL.
                if (window.location.pathname !== openedAtPathname)
                    return;
                router.push(dismissHref, undefined, 'Access gate dismissed');
            },
        });
    }, [handleRequestAccess, isRequestAccessReady, uuidOrSlug, subject, router, dismissHref]);
    return null;
}
//# sourceMappingURL=RequestAccessOnMount.js.map